import React from "react";
import { NextPage } from "next";

import Watchdog from "scenes/Watchdog";

const Index: NextPage = () => <Watchdog />;

export default Index;
